
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/message",
      function () {
        return require("private-next-pages/profile/message/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/message"])
      });
    }
  